import {
  IconAtom,
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLocation,
  IconMeter,
  IconPcLine,
  IconPlug,
  IconRoad,
  IconRoom,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTools,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { IconTemp } from '@assets/images/main';
import { rtlsSystem } from '@assets/images/solution';

import integrationVideo from '@src/assets/images/main/video/integration.mp4';

import image2 from '@src/assets/images/solution/medicalWaste/img/2.avif';
import image3 from '@src/assets/images/solution/medicalWaste/img/3.avif';
import image4 from '@src/assets/images/solution/medicalWaste/img/4.avif';
import image5 from '@src/assets/images/solution/medicalWaste/img/5.avif';
import image6 from '@src/assets/images/solution/medicalWaste/img/6.avif';
import image7 from '@src/assets/images/solution/medicalWaste/img/7.avif';
import image8 from '@src/assets/images/solution/medicalWaste/img/8.avif';
import image9 from '@src/assets/images/solution/medicalWaste/img/9.avif';

export default {
  type: 'Giải pháp y tế',

  banner: {
    title: 'Tối ưu hóa quản lý rác thải y tế bằng hệ thống tự động hóa dựa trên robot',
    desc: 'Kết hợp robot và hệ thống định vị ORBRO để theo dõi vị trí rác thải y tế theo thời gian thực và cung cấp quản lý vận hành tự động hóa.',
  },

  video: {
    title: 'Trải nghiệm quản lý rác thải y tế thông minh với hệ thống robot và định vị kết hợp',
    desc: 'Kết hợp quản lý rác thải y tế bằng robot với hệ thống định vị ORBRO giúp giám sát vị trí chính xác và quản lý tự động, từ đó nâng cao hiệu quả vận hành.',
    play: integrationVideo,
  },

  func: [
    {
      theme: 'Theo dõi vị trí robot theo thời gian thực và quản lý rác thải y tế hiệu quả.',
      title: 'Theo dõi vị trí robot & giám sát vận hành theo thời gian thực',
      desc: 'Hệ thống định vị ORBRO giúp theo dõi chính xác vị trí và trạng thái hoạt động của robot, nâng cao độ chính xác quản lý rác thải y tế và tối đa hóa hiệu quả vận hành nhờ phản ứng tức thời.',
      sub1: 'Độ chính xác cao',
      icon1: IconRulerGray,
      sub2: 'Kết nối dữ liệu nhanh',
      icon2: IconShareGray,
      image: image2,
    },
    {
      title: 'Robot tự hành di chuyển đến khu bốc dỡ',
      desc: 'Robot sử dụng công nghệ tự hành để di chuyển an toàn đến khu bốc dỡ, thực hiện công việc mà không cần con người can thiệp, nâng cao hiệu quả và đảm bảo an toàn cho nhân viên.',
      sub1: 'Chỉ định tài sản rủi ro',
      icon1: IconWarningGray,
      sub2: 'Cài đặt phương án xử lý',
      icon2: IconBellGray,
      image: image3,
    },
    {
      title: 'Vận hành tự động liên kết với thiết bị bốc dỡ',
      desc: 'Thiết lập hệ thống tự động liên kết giữa thiết bị bốc dỡ và robot để quản lý trơn tru việc gọi robot và chuẩn bị bốc dỡ, từ đó tăng hiệu quả công việc và tốc độ xử lý.',
      sub1: 'Độ chính xác cao',
      icon1: IconRulerGray,
      sub2: 'Kết nối dữ liệu nhanh',
      icon2: IconChainLinkGray,
      image: image4,
    },
    {
      title: 'Liên kết với tủ lưu trữ thông minh',
      desc: 'Liên kết hiệu quả với tủ lưu trữ thông minh và hệ thống, giúp truy cập dữ liệu và quản lý tài sản dễ dàng, tiện lợi, nâng cao tính chính xác và sự tiện dụng khi vận hành.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu trên cloud',
      icon2: IconCloudCheckGray,
      image: image5,
    },
    {
      theme: 'Kiểm tra trạng thái thiết bị theo thời gian thực, tự động quản lý khử trùng.',
      title: 'Giám sát trạng thái công việc theo thời gian thực',
      desc: 'Giám sát trạng thái công việc của từng robot theo thời gian thực, xử lý ngay khi có vấn đề xảy ra, giảm thiểu lỗi phát sinh khi vận hành, đảm bảo môi trường quản lý an toàn.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu trên cloud',
      icon2: IconCloudCheckGray,
      image: image6,
    },
    {
      title: 'Quản lý đồng thời nhiều robot',
      desc: 'Quản lý nhiều robot cùng lúc trên một hệ thống, tăng hiệu quả quản lý, tránh trùng lặp và va chạm trong quá trình làm việc, đảm bảo công việc diễn ra trôi chảy và chính xác.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu trên cloud',
      icon2: IconCloudCheckGray,
      image: image7,
    },
    {
      title: 'Liên kết và quản lý hệ thống khử trùng',
      desc: 'Dễ dàng liên kết với các thiết bị khử trùng plasma, UVC, HPV để khử trùng rác thải y tế và dụng cụ y tế một cách nhanh chóng và chính xác, duy trì môi trường sạch sẽ.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu trên cloud',
      icon2: IconCloudCheckGray,
      image: image8,
    },
    {
      title: 'Theo dõi trạng thái công việc của thiết bị theo thời gian thực',
      desc: 'Giám sát chính xác trạng thái kết nối và tiến độ công việc của từng thiết bị khử trùng theo thời gian thực, phát hiện sớm và xử lý kịp thời các vấn đề có thể phát sinh.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu trên cloud',
      icon2: IconCloudCheckGray,
      image: image9,
    },
  ],

  subfunc: {
    title: 'Tóm tắt tính năng chính',
    desc: '',

    data: [
      {
        icon: IconLocation,
        title: 'Theo dõi vị trí robot theo thời gian thực',
        desc: 'Theo dõi chính xác vị trí hiện tại của robot, giám sát trạng thái vận hành theo thời gian thực.',
      },
      {
        icon: IconMeter,
        title: 'Giám sát trạng thái công việc theo thời gian thực',
        desc: 'Phát hiện tiến độ công việc của robot theo thời gian thực để xử lý ngay lập tức.',
      },
      {
        icon: IconUserCheck,
        title: 'Quản lý đồng thời nhiều robot',
        desc: 'Quản lý nhiều robot một cách hiệu quả cùng lúc, nâng cao độ chính xác vận hành.',
      },
      {
        icon: IconRoad,
        title: 'Robot tự hành di chuyển đến khu bốc dỡ',
        desc: 'Robot tự động di chuyển đến khu bốc dỡ, tăng hiệu suất công việc và đảm bảo an toàn.',
      },
      {
        icon: IconPlug,
        title: 'Tự động liên kết với thiết bị bốc dỡ',
        desc: 'Tự động quản lý gọi robot và chuẩn bị bốc dỡ, nâng cao hiệu quả vận hành.',
      },
      {
        icon: IconPcLine,
        title: 'Bảng điều khiển quản lý robot chuyên dụng',
        desc: 'Cung cấp bảng điều khiển chuyên dụng để quản lý trực quan mọi trạng thái vận hành và dữ liệu của robot.',
      },
      {
        icon: IconRoom,
        title: 'Liên kết hệ thống tủ lưu trữ thông minh',
        desc: 'Liên kết với tủ lưu trữ để quản lý hiệu quả tình trạng lưu trữ rác thải y tế.',
      },
      {
        icon: IconTools,
        title: 'Giám sát thiết bị khử trùng theo thời gian thực',
        desc: 'Giám sát kết nối và trạng thái làm việc của từng thiết bị khử trùng theo thời gian thực, đảm bảo vận hành ổn định.',
      },
      {
        icon: IconAtom,
        title: 'Liên kết nhiều hệ thống khử trùng',
        desc: 'Dễ dàng kết nối thiết bị khử trùng plasma, UVC, HPV, hỗ trợ quy trình tiệt trùng nhanh chóng và toàn diện.',
      },
      {
        icon: IconChartBar,
        title: 'Quản lý tình hình tổng thể theo thời gian thực',
        desc: 'Quản lý toàn bộ trạng thái vận hành và tồn kho của thiết bị trên một màn hình, hỗ trợ ra quyết định nhanh.',
      },
    ],
  },

  system: {
    title: 'Cấu trúc hệ thống',
    img: rtlsSystem,
  },

  productTitle: 'Gói sản phẩm',
  product: [
    {
      tag: 'assetPackage',
    },
    {
      tag: 'workerPackage',
    },
  ],

  contents: [
    {
      data: 'medicalPatient',
    },
    {
      data: 'officeAsset',
    },
    {
      data: 'blogMedical',
    },
    {
      data: 'blogRTLS',
    },
  ],
};
